import React from 'react';
import { Container } from './UsuariosAdm.styles';

function UsuariosAdm() {
    return <Container>UsuariosAdm</Container>;
}

export default UsuariosAdm;
